/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useState, useEffect } from 'react';
import customersService from 'service/customer';
import './payment.scss';
import Button from 'components/base/Button';
import AddNewContact from './AddNewContact';

interface SearchContactProps {
  setSelectedContact?: any;
  setIsOpen: (show: boolean) => void;
}

const SearchContact = ({
  setSelectedContact,
  setIsOpen
}: SearchContactProps) => {
  const { t } = useTranslation();

  const [isOpenNewContact, setIsOpenNewContact] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [debouncedSearchValue, setDebouncedSearchValue] = useState(searchValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 400);

    return () => clearTimeout(handler);
  }, [searchValue]);

  const { data, refetch } = useQuery(
    ['GET_CUSTOMERS', debouncedSearchValue],
    () => {
      const res = customersService
        .getList({
          offset: 0,
          limit: 100,
          search: debouncedSearchValue
        })
        .then((res: any) => res?.data?.users);
      return res;
    },
    { enabled: !debouncedSearchValue || debouncedSearchValue?.length > 2 }
  );

  return (
    <div className="contact-container">
      <Form.Group className="mb-2">
        <Form.Floating className="w-100">
          <Form.Control
            type="text"
            placeholder="Base currency"
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            onFocus={e => e.target.select()}
          />
          <label htmlFor="floatingInputCustom">{t('search')}</label>
        </Form.Floating>
      </Form.Group>

      <div className="contacts">
        {data?.map((item: any) => (
          <div
            className="contact-lst"
            key={item?.id}
            onClick={() => {
              setSelectedContact(item);
              setIsOpen(false);
            }}
          >
            <p className="contact-name">
              {item?.first_name || ''} {item?.last_name || ''}
            </p>
            <p className="contact-phone">{item?.phone_number}</p>
          </div>
        ))}
      </div>

      <div
        style={{
          height: '100%',
          position: 'sticky',
          bottom: '0'
        }}
        onClick={() => setIsOpenNewContact(true)}
      >
        <Button
          style={{ height: '48px', width: '100%' }}
          variant="primary"
          type="button"
        >
          {t('add_new_contact')}
        </Button>
      </div>

      <Offcanvas
        show={isOpenNewContact}
        onHide={() => {
          setIsOpenNewContact(false);
        }}
        placement="end"
        backdrop="static"
        keyboard={false}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title style={{ fontSize: '24px', fontWeight: '600' }}>
            {t('contact')}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <AddNewContact
            setIsOpenNewContact={setIsOpenNewContact}
            refetch={refetch}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default SearchContact;
